export const salesScanToPay = {
  salesSummary: {
    GIFT_CARD: {
      id: 'GIFT_CARD',
      transactionCount: 19,
      orderTotal: 120049,
      tipTotal: 55000,
      finalTotal: 175049,
    },
    CARD_NOT_PRESENT: {
      id: 'CARD_NOT_PRESENT',
      transactionCount: 83,
      orderTotal: 746065,
      tipTotal: 215000,
      finalTotal: 961065,
    },
  },
};
